// Stub slot for the quick message button — will be replaced by a real implementation.
export default function QuickMessageSlot() {
  return null;
}
